const config = {
    apiUrl: "https://api.magicoprof.com", // "http://87.106.3.31:48000",  //http://api3e.soluzioni-it.eu/
    appName: "Ai MoX",
    author: "gMox soluzioni-it.eu",
    debugMode: true,
};

    
  export const getProfileFromToken = () => {
    const token = localStorage.getItem("token"); // Recupera il token salvato
    if (!token) {
        console.error("Nessun token trovato");
        return null;
    }
    try {
        // Decodifica il token da Base64 a stringa JSON
        const decodedString = atob(token);
        const tokenData = JSON.parse(decodedString);
        return tokenData.profilo; // Ritorna solo il profilo
    } catch (error) {
        console.error("Errore nella decodifica del token:", error);
        return null;
    }
  };
  
  export default config;
  